import SparkMD5 from 'spark-md5';

export async function calculateFileMD5(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const chunkSize = 10 * 1024 * 1024; // 每块 10MB
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();
        function loadNext() {
            const start = currentChunk * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            fileReader.readAsArrayBuffer(file.slice(start, end));
        }

        fileReader.onload = (e: any) => {
            spark.append(e.target.result);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
            } else {
                resolve(spark.end()); // 计算完成
            }
        };

        fileReader.onerror = () => reject('文件读取错误');


        loadNext();
    });
}
